
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefea6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefea6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("8tLg9", function(module, exports) {
module.exports = new URL("2k_stars_milky_way.724715d3.jpg", import.meta.url).toString();

});

parcelRegister("6dVhZ", function(module, exports) {
module.exports = new URL("2k_venus_atmosphere.6b67833a.jpg", import.meta.url).toString();

});

parcelRegister("bneSh", function(module, exports) {
module.exports = new URL("RS3_EarthC.aaeaa98f.jpg", import.meta.url).toString();

});

parcelRegister("boFjS", function(module, exports) {
module.exports = new URL("2k_jupiter.6180ba4a.jpg", import.meta.url).toString();

});

parcelRegister("3fSvu", function(module, exports) {
module.exports = new URL("2k_uranus.d1e141cb.jpg", import.meta.url).toString();

});

parcelRegister("cri0F", function(module, exports) {
module.exports = new URL("2k_neptune.5fc74549.jpg", import.meta.url).toString();

});

parcelRegister("3j72e", function(module, exports) {
module.exports = new URL("th.097e04fb.jpeg", import.meta.url).toString();

});

parcelRegister("lkuI6", function(module, exports) {
module.exports = new URL("2k_sun.defafe91.jpg", import.meta.url).toString();

});

parcelRegister("afWdh", function(module, exports) {
module.exports = new URL("2k_mercury.42e2b735.jpg", import.meta.url).toString();

});

parcelRegister("21K3A", function(module, exports) {
module.exports = new URL("2k_mars.6e9645ec.jpg", import.meta.url).toString();

});

parcelRegister("4qH3O", function(module, exports) {
module.exports = new URL("2k_saturn.024c2f02.jpg", import.meta.url).toString();

});

parcelRegister("8vFPr", function(module, exports) {
module.exports = new URL("2k_saturn_ring_alpha.d9c19af5.png", import.meta.url).toString();

});

parcelRegister("7Hsmk", function(module, exports) {
module.exports = new URL("2k_moon.7ce750a3.jpg", import.meta.url).toString();

});

var $0ffa341c64de067e$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["bMsed","index.0ffa0061.js","kkm0a","2k_stars_milky_way.724715d3.jpg","kYCeB","2k_venus_atmosphere.6b67833a.jpg","ko2HD","RS3_EarthC.aaeaa98f.jpg","bcu87","2k_jupiter.6180ba4a.jpg","hxmPk","2k_uranus.d1e141cb.jpg","9alQm","2k_neptune.5fc74549.jpg","8Qzke","th.097e04fb.jpeg","dB8VS","2k_sun.defafe91.jpg","g3ADe","2k_mercury.42e2b735.jpg","lA6ca","2k_mars.6e9645ec.jpg","3NBD5","2k_saturn.024c2f02.jpg","gkBSn","2k_saturn_ring_alpha.d9c19af5.png","hDmsS","2k_moon.7ce750a3.jpg","gitrq","Solar System.8b519564.js"]'));


var $ilwiq = parcelRequire("ilwiq");

var $5Rd1x = parcelRequire("5Rd1x");

var $8tLg9 = parcelRequire("8tLg9");

var $lkuI6 = parcelRequire("lkuI6");

var $afWdh = parcelRequire("afWdh");

var $6dVhZ = parcelRequire("6dVhZ");

var $21K3A = parcelRequire("21K3A");

var $bneSh = parcelRequire("bneSh");

var $boFjS = parcelRequire("boFjS");

var $4qH3O = parcelRequire("4qH3O");

var $8vFPr = parcelRequire("8vFPr");

var $3fSvu = parcelRequire("3fSvu");

var $cri0F = parcelRequire("cri0F");

var $3j72e = parcelRequire("3j72e");

var $7Hsmk = parcelRequire("7Hsmk");
const $430167e599c6996c$var$renderer = new $ilwiq.WebGLRenderer();
$430167e599c6996c$var$renderer.setSize(window.innerWidth, window.innerHeight);
document.body.appendChild($430167e599c6996c$var$renderer.domElement);
const $430167e599c6996c$var$scene = new $ilwiq.Scene();
const $430167e599c6996c$var$camera = new $ilwiq.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);
const $430167e599c6996c$var$orbit = new (0, $5Rd1x.OrbitControls)($430167e599c6996c$var$camera, $430167e599c6996c$var$renderer.domElement);
$430167e599c6996c$var$camera.position.set(-90, 140, 140);
$430167e599c6996c$var$orbit.update();
const $430167e599c6996c$var$ambientLight = new $ilwiq.AmbientLight(0x333333);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$ambientLight);
const $430167e599c6996c$var$cubeTextureLoad = new $ilwiq.CubeTextureLoader();
$430167e599c6996c$var$scene.background = $430167e599c6996c$var$cubeTextureLoad.load([
    (0, (/*@__PURE__*/$parcel$interopDefault($8tLg9)))
]);
const $430167e599c6996c$var$textureLoader = new $ilwiq.TextureLoader();
//*SUN
const $430167e599c6996c$var$sunGeo = new $ilwiq.SphereGeometry(20, 30, 30);
const $430167e599c6996c$var$sunMat = new $ilwiq.MeshBasicMaterial({
    map: $430167e599c6996c$var$textureLoader.load((0, (/*@__PURE__*/$parcel$interopDefault($lkuI6))))
});
const $430167e599c6996c$var$sun = new $ilwiq.Mesh($430167e599c6996c$var$sunGeo, $430167e599c6996c$var$sunMat);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$sun);
//planets
function $430167e599c6996c$var$createplanets(size, texture, position, positionY, ring) {
    const geo = new $ilwiq.SphereGeometry(size, 30, 30);
    const mat = new $ilwiq.MeshStandardMaterial({
        map: $430167e599c6996c$var$textureLoader.load(texture)
    });
    const mesh = new $ilwiq.Mesh(geo, mat);
    //scene.add(sun);
    const obj = new $ilwiq.Object3D();
    obj.add(mesh);
    if (ring) {
        const ringGeo = new $ilwiq.RingGeometry(ring.innerRadius, ring.outerRadius, 34);
        const ringMat = new $ilwiq.MeshBasicMaterial({
            map: $430167e599c6996c$var$textureLoader.load(ring.texture),
            side: $ilwiq.DoubleSide
        });
        const ringMesh = new $ilwiq.Mesh(ringGeo, ringMat);
        //scene.add(sun);
        obj.add(ringMesh);
        ringMesh.position.x = position;
        ringMesh.rotation.x = -0.5 * Math.PI;
    }
    $430167e599c6996c$var$scene.add(obj);
    mesh.position.x = position;
    mesh.position.y = positionY;
    return {
        mesh: mesh,
        obj: obj
    };
}
//near earth object
//near earth objects
// Stars
function $430167e599c6996c$var$createStar() {
    const geometry = new $ilwiq.SphereGeometry(0.7, 16, 16);
    const material = new $ilwiq.MeshBasicMaterial({
        color: 0xffff
    });
    const star = new $ilwiq.Mesh(geometry, material);
    // Random position for stars
    star.position.set((Math.random() - 0.6) * 320, (Math.random() - 0.4) * 10, (Math.random() - 0.5) * 350);
    $430167e599c6996c$var$scene.add(star);
}
// Create multiple stars
for(let i = 0; i < 100; i++)$430167e599c6996c$var$createStar();
//* MERCURY
const $430167e599c6996c$var$mercury = $430167e599c6996c$var$createplanets(3.2, (0, (/*@__PURE__*/$parcel$interopDefault($afWdh))), 28, 0);
const $430167e599c6996c$var$mercuryObj = new $ilwiq.Object3D();
$430167e599c6996c$var$mercuryObj.add($430167e599c6996c$var$mercury);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$mercuryObj);
//mercury orbitpath
const $430167e599c6996c$var$mercuryRingGeo = new $ilwiq.RingGeometry(28, 29, 65);
const $430167e599c6996c$var$mercuryRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0xffff00,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$mercuryRing = new $ilwiq.Mesh($430167e599c6996c$var$mercuryRingGeo, $430167e599c6996c$var$mercuryRingMat);
$430167e599c6996c$var$mercuryObj.add($430167e599c6996c$var$mercuryRing);
$430167e599c6996c$var$mercuryRing.rotateX(190.1);
$430167e599c6996c$var$mercuryRing.position.x = 0;
//venus
const $430167e599c6996c$var$venus = $430167e599c6996c$var$createplanets(5.8, (0, (/*@__PURE__*/$parcel$interopDefault($6dVhZ))), 44, 0);
const $430167e599c6996c$var$venusObj = new $ilwiq.Object3D();
$430167e599c6996c$var$venusObj.add($430167e599c6996c$var$venus);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$venusObj);
//venus orbitpath
const $430167e599c6996c$var$venusRingGeo = new $ilwiq.RingGeometry(45, 46, 65);
const $430167e599c6996c$var$venusRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0x0f5f5f,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$venusRing = new $ilwiq.Mesh($430167e599c6996c$var$venusRingGeo, $430167e599c6996c$var$venusRingMat);
$430167e599c6996c$var$venusObj.add($430167e599c6996c$var$venusRing);
$430167e599c6996c$var$venusRing.rotateX(190.1);
$430167e599c6996c$var$venusRing.position.x = 0;
//earth
const $430167e599c6996c$var$earth = $430167e599c6996c$var$createplanets(6, (0, (/*@__PURE__*/$parcel$interopDefault($bneSh))), 62, 0);
const $430167e599c6996c$var$earthObj = new $ilwiq.Object3D();
$430167e599c6996c$var$earthObj.add($430167e599c6996c$var$earth);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$earthObj);
//earth orbitpath
const $430167e599c6996c$var$earthRingGeo = new $ilwiq.RingGeometry(63, 64, 65);
const $430167e599c6996c$var$earthRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0x00ffff,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$earthRing = new $ilwiq.Mesh($430167e599c6996c$var$earthRingGeo, $430167e599c6996c$var$earthRingMat);
$430167e599c6996c$var$earthObj.add($430167e599c6996c$var$earthRing);
$430167e599c6996c$var$earthRing.rotateX(190.1);
$430167e599c6996c$var$earthRing.position.x = 0;
//earth-moon
const $430167e599c6996c$var$moon = $430167e599c6996c$var$createplanets(1, (0, (/*@__PURE__*/$parcel$interopDefault($7Hsmk))), 69, 5);
//mars
const $430167e599c6996c$var$mars = $430167e599c6996c$var$createplanets(4, (0, (/*@__PURE__*/$parcel$interopDefault($21K3A))), 78, 0);
const $430167e599c6996c$var$marsObj = new $ilwiq.Object3D();
$430167e599c6996c$var$marsObj.add($430167e599c6996c$var$mars);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$marsObj);
//mars orbitpath
const $430167e599c6996c$var$marsRingGeo = new $ilwiq.RingGeometry(76, 77, 65);
const $430167e599c6996c$var$marsRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0xff9C38,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$marsRing = new $ilwiq.Mesh($430167e599c6996c$var$marsRingGeo, $430167e599c6996c$var$marsRingMat);
$430167e599c6996c$var$marsObj.add($430167e599c6996c$var$marsRing);
$430167e599c6996c$var$marsRing.rotateX(190.1);
$430167e599c6996c$var$marsRing.position.x = 0;
//jupiter
const $430167e599c6996c$var$jupiter = $430167e599c6996c$var$createplanets(12, (0, (/*@__PURE__*/$parcel$interopDefault($boFjS))), 100, 0);
const $430167e599c6996c$var$jupiterObj = new $ilwiq.Object3D();
$430167e599c6996c$var$jupiterObj.add($430167e599c6996c$var$jupiter);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$jupiterObj);
//jupiter orbitpath
const $430167e599c6996c$var$jupiterRingGeo = new $ilwiq.RingGeometry(98, 99, 75);
const $430167e599c6996c$var$jupiterRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0x00DB58,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$jupiterRing = new $ilwiq.Mesh($430167e599c6996c$var$jupiterRingGeo, $430167e599c6996c$var$jupiterRingMat);
$430167e599c6996c$var$jupiterObj.add($430167e599c6996c$var$jupiterRing);
$430167e599c6996c$var$jupiterRing.rotateX(190.1);
//SATURN
const $430167e599c6996c$var$saturn = $430167e599c6996c$var$createplanets(10, (0, (/*@__PURE__*/$parcel$interopDefault($4qH3O))), 138, 0, {
    innerRadius: 12,
    outerRadius: 24,
    texture: (0, (/*@__PURE__*/$parcel$interopDefault($8vFPr)))
});
const $430167e599c6996c$var$saturnObj = new $ilwiq.Object3D();
$430167e599c6996c$var$saturnObj.add($430167e599c6996c$var$mars);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$saturnObj);
//saturn orbitpath
const $430167e599c6996c$var$saturnRingGeo = new $ilwiq.RingGeometry(134, 135, 75);
const $430167e599c6996c$var$saturnRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0xCBA8FF,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$saturnRing = new $ilwiq.Mesh($430167e599c6996c$var$saturnRingGeo, $430167e599c6996c$var$saturnRingMat);
$430167e599c6996c$var$saturnObj.add($430167e599c6996c$var$saturnRing);
$430167e599c6996c$var$saturnRing.rotateX(190.1);
$430167e599c6996c$var$saturnRing.position.x = 0;
//uranus
const $430167e599c6996c$var$uranus = $430167e599c6996c$var$createplanets(7, (0, (/*@__PURE__*/$parcel$interopDefault($3fSvu))), 176, 0);
const $430167e599c6996c$var$uranusObj = new $ilwiq.Object3D();
$430167e599c6996c$var$uranusObj.add($430167e599c6996c$var$uranus);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$uranusObj);
//uranus orbitpath
const $430167e599c6996c$var$uranusRingGeo = new $ilwiq.RingGeometry(174, 175, 75);
const $430167e599c6996c$var$uranusRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0xff3d3d,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$uranusRing = new $ilwiq.Mesh($430167e599c6996c$var$uranusRingGeo, $430167e599c6996c$var$uranusRingMat);
$430167e599c6996c$var$uranusObj.add($430167e599c6996c$var$uranusRing);
$430167e599c6996c$var$uranusRing.rotateX(190.1);
$430167e599c6996c$var$marsRing.position.x = 0;
//neptune
const $430167e599c6996c$var$neptune = $430167e599c6996c$var$createplanets(7, (0, (/*@__PURE__*/$parcel$interopDefault($cri0F))), 200, 0);
const $430167e599c6996c$var$neptuneObj = new $ilwiq.Object3D();
$430167e599c6996c$var$neptuneObj.add($430167e599c6996c$var$mars);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$neptuneObj);
//neptune orbitpath
const $430167e599c6996c$var$neptuneRingGeo = new $ilwiq.RingGeometry(198, 199, 75);
const $430167e599c6996c$var$neptuneRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0x005C5C,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$neptuneRing = new $ilwiq.Mesh($430167e599c6996c$var$neptuneRingGeo, $430167e599c6996c$var$neptuneRingMat);
$430167e599c6996c$var$neptuneObj.add($430167e599c6996c$var$neptuneRing);
$430167e599c6996c$var$neptuneRing.rotateX(190.1);
$430167e599c6996c$var$neptuneRing.position.x = 0;
//pluto
const $430167e599c6996c$var$pluto = $430167e599c6996c$var$createplanets(2.8, (0, (/*@__PURE__*/$parcel$interopDefault($3j72e))), 216, 0);
const $430167e599c6996c$var$plutoObj = new $ilwiq.Object3D();
$430167e599c6996c$var$plutoObj.add($430167e599c6996c$var$pluto);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$plutoObj);
//pluto orbitpath
const $430167e599c6996c$var$plutoRingGeo = new $ilwiq.RingGeometry(213, 215, 75);
const $430167e599c6996c$var$plutoRingMat = new $ilwiq.MeshBasicMaterial({
    color: 0xffffff,
    side: $ilwiq.DoubleSide
});
const $430167e599c6996c$var$plutoRing = new $ilwiq.Mesh($430167e599c6996c$var$plutoRingGeo, $430167e599c6996c$var$plutoRingMat);
$430167e599c6996c$var$plutoObj.add($430167e599c6996c$var$plutoRing);
$430167e599c6996c$var$plutoRing.rotateX(190.1);
//pointerlight
const $430167e599c6996c$var$pointLight = new $ilwiq.PointLight(0xffffff, 3, 300, 0.1);
$430167e599c6996c$var$scene.add($430167e599c6996c$var$pointLight);
function $430167e599c6996c$var$animate() {
    //self-rotation
    $430167e599c6996c$var$sun.rotateY(0.004);
    $430167e599c6996c$var$mercury.mesh.rotateY(0.004);
    $430167e599c6996c$var$venus.mesh.rotateY(0.004);
    $430167e599c6996c$var$earth.mesh.rotateY(0.02);
    $430167e599c6996c$var$mars.mesh.rotateY(0.018);
    $430167e599c6996c$var$jupiter.mesh.rotateY(0.04);
    $430167e599c6996c$var$neptune.mesh.rotateY(0.032);
    $430167e599c6996c$var$uranus.mesh.rotateY(0.03);
    $430167e599c6996c$var$pluto.mesh.rotateY(0.008);
    $430167e599c6996c$var$saturn.mesh.rotateY(0.038);
    //around-sun-rotation
    $430167e599c6996c$var$mercury.obj.rotateY(0.04);
    $430167e599c6996c$var$venus.obj.rotateY(0.015);
    $430167e599c6996c$var$earth.obj.rotateY(0.01);
    $430167e599c6996c$var$moon.obj.rotateY(0.01);
    $430167e599c6996c$var$mars.obj.rotateY(0.008);
    $430167e599c6996c$var$jupiter.obj.rotateY(0.002);
    $430167e599c6996c$var$uranus.obj.rotateY(0.0004);
    $430167e599c6996c$var$neptune.obj.rotateY(0.0001);
    $430167e599c6996c$var$pluto.obj.rotateY(0.00007);
    $430167e599c6996c$var$saturn.obj.rotateY(0.0009);
    $430167e599c6996c$var$renderer.render($430167e599c6996c$var$scene, $430167e599c6996c$var$camera);
}
$430167e599c6996c$var$renderer.setAnimationLoop($430167e599c6996c$var$animate);
window.addEventListener("resize", function() {
    $430167e599c6996c$var$camera.aspect = window.innerWidth / window.innerHeight;
    $430167e599c6996c$var$camera.updateProjectionMatrix();
    $430167e599c6996c$var$renderer.setSize(window.innerWidth, window.innerHeight);
});


//# sourceMappingURL=index.0ffa0061.js.map
